function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "eye");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32,48c20.27,0,31.35-14.78,31.81-15.41l.43-.59-.43-.59C63.35,30.78,52.27,16,32,16S.65,30.78.19,31.41L-.24,32l.43.59C.65,33.22,11.73,48,32,48Zm0-30c17,0,27.43,11.26,29.72,14C59.43,34.74,49,46,32,46S4.57,34.74,2.28,32C4.57,29.26,15,18,32,18Z",
  transform: "translate(0.24 -16)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32,40a8,8,0,1,0-8-8A8,8,0,0,0,32,40Zm0-14a6,6,0,1,1-6,6A6,6,0,0,1,32,26Z",
  transform: "translate(0.24 -16)"
});

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64.48 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.bf8bf80b.svg";
export { ForwardRef as ReactComponent };